import React, { useState, useEffect } from "react";
import styles from './UserManager.module.scss';
import { getUsers, deleteUser } from "../../../../../ApiLayer/admin";
import AddUserForm from "../Users/AddUserForm";
import ConfirmPopup from "../../../../../Components/ConfirmPopupComponent/ConfirmPopup";
import UserList from "../Users/UserList";

const UserManagerTab = () => {
    const [users, setUsers] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [showAddUserForm, setShowAddUserForm] = useState(false);
    const [userToDelete, setUserToDelete] = useState("");
    const [showConfirmPopup, setShowConfirmPopup] = useState(false);
    const [message, setMessage] = useState("");

    const handleDeleteUser = async (e) => {
        e.preventDefault();
        setMessage("");

        try {
            const response = await deleteUser({ email: userToDelete });

            if (!response.success) {
                // console.log("Error deleting user:   ", response.data);
                setMessage(response.message);
                return;
            }

            setMessage(response.message);
            setShowConfirmPopup(false);
            getUserData();
        } catch (err) {
            // console.log("Error deleting user:   ", err);
            setMessage("Error deleting user");
        }
    };

    const handleAddUserSuccess = () => {
        setShowAddUserForm(false);
        getUserData();
    };

    const handleToggleConfirmPopup = (e, email) => {
        e.preventDefault();
        setShowConfirmPopup((prev) => !prev);
        setUserToDelete(email);
    };

    const getUserData = async () => {
        try {
            setLoading(true);
            setError(null);
            const response = await getUsers();

            if (response.success) {
                setUsers(response.users || []);
            } else {
                setError(response.message || "Failed to fetch users");
            }
        } catch (err) {
            // console.log("Error getting Users:   ", err);
            setError("An error occurred while fetching users");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        getUserData();
    }, []);

    return (
        <div className={styles.tabContent}>
            <h2>User Manager</h2>
            {message && <div className={styles.message}>{message}</div>}
            {loading ? (
                <div className={styles.loading}>Loading users...</div>
            ) : error ? (
                <div className={styles.error}>{error}</div>
            ) : (
                <>
                    <UserList 
                        users={users} 
                        onDelete={handleToggleConfirmPopup}
                    />
                    {showAddUserForm && (
                        <AddUserForm
                            onSuccess={handleAddUserSuccess}
                            onCancel={() => setShowAddUserForm(false)}
                        />
                    )}
                    {!showAddUserForm && (
                        <div
                            onClick={() => setShowAddUserForm(true)}
                            className={styles.addUserContainer}
                        >
                            <h5>+ Add User</h5>
                        </div>
                    )}
                </>
            )}
            <ConfirmPopup
                isOpen={showConfirmPopup}
                onClose={() => setShowConfirmPopup(false)}
                onConfirm={handleDeleteUser}
                title="Delete User"
                confirmText="Delete"
                message={`Are you sure you want to delete ${userToDelete} from users?`}
            />
        </div>
    );
};

export default UserManagerTab;
